import { render, staticRenderFns } from "./EmailConteudo.vue?vue&type=template&id=5690d550&scoped=true"
import script from "./EmailConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmailConteudo.vue?vue&type=style&index=0&id=5690d550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5690d550",
  null
  
)

export default component.exports